import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "antd";

import { Loader, Spacer, application, boxContainer } from "../../components";

import { ApplicationAction } from "../../store/actions";

function Applications() {
  const dispatch = useDispatch();

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [pageNo, setPageNo] = useState(1);

  const { applications, count, isLoading } = useSelector(
    (state) => state.application
  );
  const profileData = useSelector((state) => state.profile?.user);
  const schoolId =
    profileData?.role === "school"
      ? profileData?.schoolId
      : profileData?.staff?.schoolId;

  useEffect(() => {
    const payload = { limit, offset, schoolId };
    dispatch(ApplicationAction.getApplications(payload));
  }, [limit, offset, profileData]);

  const handlePagination = (page, pageSize) => {
    const offset = (page - 1) * pageSize;
    setPageNo(page);
    setLimit(pageSize);
    setOffset(offset);
  };

  return (
    <div className="text-black">
      <boxContainer.LiteBoxContainer>
        {isLoading ? (
          <Loader.Circular />
        ) : (
          <div>
            <application.ApplicationTopAnalytics />
            <Spacer height={20} />
            <div className="text-[1.25em] font-semibold">
              Universities That Students Have Applied To
            </div>
            <Spacer height={20} />
            <div className="flex flex-col gap-4">
              {applications?.map((item, index) => (
                <application.ApplicationRow item={item} key={index} />
              ))}
            </div>
            <Spacer height={20} />
            <div className="flex items-center justify-center">
              <Pagination
                responsive
                showSizeChanger
                current={pageNo}
                pageSize={limit}
                total={count}
                onChange={handlePagination}
                onShowSizeChange={handlePagination}
              />
            </div>
          </div>
        )}
      </boxContainer.LiteBoxContainer>
    </div>
  );
}

export default Applications;
